import React from 'react';
type SectionHeadingProps = {
  eyebrow: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
};
export function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'left'
}: SectionHeadingProps) {
  const alignment = align === 'center' ? 'mx-auto text-center' : '';
  return <div className={`max-w-2xl ${alignment}`} data-id="element-256">
      <p className="mb-4 text-[10px] font-bold uppercase tracking-[0.25em] text-[#a66e2e]" data-id="element-257">
        {eyebrow}
      </p>
      <h2 className="font-serif text-4xl leading-[1.05] text-[#17362e] sm:text-5xl" data-id="element-258">
        {title}
      </h2>
      {description && <p className="mt-5 text-base leading-7 text-[#52635a]" data-id="element-259">{description}</p>}
    </div>;
}